import { useTranslate } from "@made-people/grease-translations";

export const SwipeIndicator = () => {
  const translate = useTranslate();
  return (
    <div className="flex items-center justify-center gap-6 py-6 w-full text-center font-semibold text-[1.4rem] lg:hidden">
      <svg
        className="w-8 h-8"
        width="28"
        height="31"
        viewBox="0 0 28 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.89014 4.83673V3.14339C2.89014 2.59673 2.4368 2.14339 1.89014 2.14339C1.34347 2.14339 0.890137 2.59673 0.890137 3.14339V7.47673C0.890137 8.21006 1.49014 8.81006 2.22347 8.81006H6.5568C7.10347 8.81006 7.5568 8.35673 7.5568 7.81006C7.5568 7.26339 7.10347 6.81006 6.5568 6.81006H3.6768C6.49014 4.33006 10.1835 2.81006 14.2235 2.81006C20.1168 2.81006 23.9168 5.73006 25.2235 8.27673C25.3835 8.61006 25.7301 8.81006 26.1035 8.81006C26.8501 8.81006 27.3435 8.02339 26.9968 7.37006C25.2901 3.99673 20.6368 0.810059 14.2235 0.810059C9.93014 0.810059 5.98347 2.31673 2.89014 4.83673ZM5.1568 22.7167C5.1568 21.8501 5.9568 21.2101 6.81014 21.3967L11.5568 22.4634V8.14339C11.5568 7.03673 12.4501 6.14339 13.5568 6.14339C14.6635 6.14339 15.5568 7.03673 15.5568 8.14339V16.1434H16.7701C17.1835 16.1434 17.5968 16.2367 17.9568 16.4234L23.4101 19.1434C24.4368 19.6501 25.0235 20.7701 24.8635 21.9034L24.0235 27.8501C23.8368 29.1701 22.7035 30.1434 21.3835 30.1434H13.1701C12.4635 30.1434 11.4501 29.8634 10.9568 29.3567L5.53014 23.6367C5.289 23.3915 5.15477 23.0607 5.1568 22.7167Z"
          fill="#383838"
        />
      </svg>
      <p>{translate("Size_Guide_Swipe_Text")}</p>
    </div>
  );
};
